module.exports = require('./relation-getters.js');